// extracted by mini-css-extract-plugin
export default {"checkedBox":"DfGKFyOuarCiTBLu_SHg"};